import { render, staticRenderFns } from "./FileStatisticsReport.vue?vue&type=template&id=066ec9a3&"
import script from "./FileStatisticsReport.vue?vue&type=script&lang=js&"
export * from "./FileStatisticsReport.vue?vue&type=script&lang=js&"
import style0 from "./FileStatisticsReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports